import {
  Button,
  Card,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import dashboardImg from "../../assets/img/Dashboard.png";

import { Box, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import Style from "../../styles/login.module.scss";
import { Link, useNavigate } from "react-router-dom";
import SnackUI from "../../common/SnackUI";
import { useDispatch, useSelector } from "react-redux";
import { registerUserAction } from "../../redux/toolkit/auth/registerUser";
import { forgetPasswordAction } from "../../redux/toolkit/auth/forgetpassword";
import { checkOtpAction } from "../../redux/toolkit/auth/checkotp";

const NewForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [c_password, setCPassword] = useState("");
  const [snack, setSnack] = useState(false);
  const [wait, setWait] = useState(false);
  const [timer, setTimer] = useState(30);
  const [btnTxt, setBtnTxt] = useState("SEND EMAIL");
  const [optSnack, setOptSnack] = useState(false);

  const otpSelector = useSelector((state) => state.forgetpassword);
  const { message, status, loading } = otpSelector;

  const {
    message: otpMessage,
    status: OtpStatus,
    loading: otpLoading,
  } = useSelector((state) => state.checkotp);

  const handleRegister = async (e) => {
    e.preventDefault();
    const registerData = await dispatch(
      registerUserAction({ name, email, password, c_password })
    );
    if (registerData?.payload?.status == 200) {
      setTimeout(() => {
        navigate("/login");
      }, 3000);
      //message = "Your account has been created succussfully, Please login now at login screen"
    }
    setSnack(true);
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    const emailres = await dispatch(forgetPasswordAction({ email }));
    if (emailres?.payload.status == 200) {
      setWait(true);
    }

    setSnack(true);
  };

  useEffect(() => {
    let intervalId;
    if (wait) {
      intervalId = setInterval(() => {
        setTimer((prevSeconds) => prevSeconds - 1);
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [wait]);

  useEffect(() => {
    if (timer === 0) {
      setWait(false);
      setTimer(30);
      setBtnTxt("RESEND EMAIL");

      // clearInterval(intervalId);
      // You can add logic here for what to do when the timer reaches zero
    }
  }, [timer]);

  const verifyOtp = async (e) => {
    e.preventDefault();
    const checkOtpRes = await dispatch(checkOtpAction({ email, password }));
    if (checkOtpRes?.payload?.status == 200) {
      localStorage.setItem("auth_token", checkOtpRes?.payload?.token);
      navigate("/changepassword");
      window.location.reload();
    }
    setOptSnack(true);
  };
  return (
    <>
      <div className="container">
        <div className="header">
          {/* <div className="left-header">
            <p>Real Opinion</p>
          </div>
          <div className="right-header">
            <p>
              Already a user ?
              <button onClick={() => navigate("/login")}>Login</button>
            </p>
          </div> */}
        </div>

        <div className="form-image-container">
          <div className="form-container">
            <div className="form-header">
              <p className="p1">welcome</p>
              <p className="p3">Forgot Password</p>
              {/* <p className="p2">Lorem ipsum dolor sit amet, consectetur adip</p> */}
            </div>

            <div className="form">
              <div className="form-fields">
                <form className="spacey4">
                  <div className="field-wrap">
                    <label htmlFor="email">Registered Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter Your Registred Email Address"
                    />
                  </div>

                  <div className="field-wrap">
                    <label>
                      fill the 6 digit code sent to email 
                    </label>
                    <input
                      type="text"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter 6 digit code"
                    />
                  </div>

                  {/* <div className="new-forgot-password">
                    {wait ? (
                    <button
                      disabled={wait ? true : false}
                      onClick={sendEmail}
                    >{`wait(${timer})`}</button>
                  ) : (
                    <button
                      disabled={email != "" ? false : true}
                      onClick={sendEmail}
                     
                      variant="contained"
                    >
                      {btnTxt}
                    </button>
                  )}
                  <button
                    disabled={email != "" && password != "" ? false : true}
                    onClick={verifyOtp}
                   
                  >
                    CONTINUE
                  </button>
                  </div> */}

                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ marginBottom: "30px" }}
                  >
                    {wait ? (
                      <Button
                        disabled={wait ? true : false}
                        onClick={sendEmail}
                        sx={{
                          backgroundColor: "rgba(142, 45, 226, 1)",
                          width: "50%",
                          letterSpacing: "3.877px",
                        }}
                        variant="contained"
                      >{`wait(${timer})`}</Button>
                    ) : (
                      <Button
                        disabled={email != "" ? false : true}
                        onClick={sendEmail}
                        sx={{
                          // backgroundColor: "rgba(142, 45, 226, 1)",
                          "&:hover": {
                            backgroundColor: "#000",
                          },
                          backgroundColor: "#000",
                          width: "50%",
                          letterSpacing: "3.877px",
                        }}
                        variant="contained"
                      >
                        {btnTxt}
                      </Button>
                    )}
                    <Button
                      disabled={email != "" && password != "" ? false : true}
                      onClick={verifyOtp}
                      sx={{
                        // backgroundColor: "rgba(142, 45, 226, 1)",
                        "&:hover": {
                          backgroundColor: "#000",
                        },
                        backgroundColor: "#000",
                        width: "50%",
                        letterSpacing: "3.877px",
                      }}
                      variant="contained"
                    >
                      CONTINUE
                    </Button>
                  </Stack>

                  <Stack>
                    <Typography
                      color="#585858"
                      marginTop="18%"
                      fontSize="15px"
                      variant="subtitle2"
                      align="right"
                    >{`Remembered your Password?`}</Typography>

                    <Typography
                      variant="h6"
                      sx={{ color: "rgba(142, 45, 226, 1)", fontSize: "1.1em" }}
                      align="right"
                      disabled={loading}
                    >
                      <Link
                        style={{ 
                          textDecoration: "none",
                          color:"#000", 
                          width: "100%" }}
                        to="/login"
                      >
                        {loading ? <CircularProgress /> : "Back To Login"}
                      </Link>
                    </Typography>
                  </Stack>
                </form>
              </div>
            </div>
          </div>

          <div className="img-container">
            <img src={dashboardImg} alt="" />
          </div>
        </div>

        <div className="footer">
          <p>2025 Real Opinion | All Rights Reserved</p>
        </div>
      </div>

      {snack && (
        <SnackUI
          state={snack}
          setState={setSnack}
          status={status}
          message={message}
        />
      )}
      {optSnack && (
        <SnackUI
          state={optSnack}
          setState={setOptSnack}
          status={OtpStatus}
          message={otpMessage}
        />
      )}
    </>
  );
};

export default NewForgetPassword;
